import { SITE } from "@/config";
import { Chapter, Reveal } from "@/components/Reveal";
import { PrimaryCTA, GhostCTA } from "@/components/CTA";

const MICRO = ["5 aree analizzate", "8–12 minuti", "Analisi gratuita"];

const Freedom = () => (
  <section id="bf360" data-testid="bf360-section" className="bg-anthracite py-28 text-white lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="06" label="Il punto di partenza" dark />
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="max-w-xl font-display text-2xl font-extrabold leading-snug tracking-tight text-white/90 md:text-3xl">
              Un'azienda può avere <span className="text-accent">successo</span> e allo stesso tempo
              toglierti la <span className="text-accent">libertà</span>.
            </p>
            <p className="mt-6 font-display text-xl font-bold tracking-tight text-white/60 md:text-2xl">
              E la tua?
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <h2 className="font-display text-4xl font-extrabold tracking-tighter sm:text-5xl lg:text-6xl">
                BUSINESS FREEDOM 360
              </h2>
              <span className="border border-accent px-3 py-1.5 font-mono text-[11px] tracking-[0.3em] text-accent">
                BF360
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-10 max-w-xl font-display text-2xl font-bold leading-snug tracking-tight text-white/90 md:text-3xl">
              Quanto sei realmente libero dalla tua azienda?
            </p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/60 md:text-lg">
              Il Business Freedom 360 analizza 5 aree della tua realtà imprenditoriale per aiutarti a
              capire quanto la tua azienda sia autonoma e quanto dipenda ancora dalla tua presenza.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-10 flex flex-wrap gap-3" data-testid="bf360-microinfo">
            {MICRO.map((m) => (
              <span
                key={m}
                className="border border-accent/30 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-accent"
              >
                {m}
              </span>
            ))}
          </Reveal>
          <Reveal delay={0.2} className="mt-12 flex flex-wrap items-center gap-4">
            <PrimaryCTA href={SITE.bf360} testid="bf360-cta">
              Scopri il tuo indice di libertà
            </PrimaryCTA>
            <GhostCTA to="/bf360" dark testid="bf360-cta-secondary">
              Cos'è BF360
            </GhostCTA>
          </Reveal>
        </div>

        <div className="flex flex-col justify-end gap-10 lg:col-span-5">
          <Reveal delay={0.15} className="flex items-center gap-6">
            <div className="relative h-36 w-36 shrink-0" data-testid="bf360-score-preview">
              <svg viewBox="0 0 144 144" className="h-full w-full -rotate-90" aria-hidden="true">
                <circle cx="72" cy="72" r="62" fill="none" stroke="rgba(245,243,238,0.08)" strokeWidth="6" />
                <circle cx="72" cy="72" r="62" fill="none" stroke="#D4AF37" strokeWidth="6" strokeDasharray="250 390" />
                <circle cx="72" cy="72" r="48" fill="none" stroke="rgba(212,175,55,0.25)" strokeWidth="1" strokeDasharray="3 5" />
              </svg>
              <span className="absolute inset-0 flex items-center justify-center font-display text-3xl font-extrabold text-white/55">—</span>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-accent">BF360</p>
              <p className="mt-2 max-w-[210px] font-mono text-[10px] uppercase leading-relaxed tracking-[0.2em] text-white/45">
                Indice di Libertà Imprenditoriale
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.2} className="border border-white/10 p-8">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-accent">Attivo — Gratuito</p>
            <p className="mt-4 text-sm leading-relaxed text-white/50">
              Questionario, scoring e report: BF360 misura oggi quanto la tua azienda dipende da te.
              È il primo passo dell'ecosistema di consulenza.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Freedom;
